// ==============
// = Pagination =
// ==============

// Adds Pjax support to pagination
// TODO: Github-style Tree slider using HTML5 History API
// https://github.com/blog/760-the-tree-slider
var Pagination = {
  links: "nav.pagination a",
  target: ".paginated-results",

  init: function () {
    jQuery(Pagination.links).pjax(Pagination.target, {
      fragment: Pagination.target,
    });

    jQuery(Pagination.target).on("pjax:start", function () {
      jQuery(this).addClass("loading");
      jQuery("html, body").animate({ scrollTop: jQuery(Pagination.target).offset().top }, "fast");
    });

    jQuery(Pagination.target).on("pjax:end", function () {
      jQuery(this).removeClass("loading");
    });
  },
};

jQuery(document).ready(Pagination.init);
